import { useEffect, useState } from "react";
import { Cookie } from "lucide-react";
import { loadGA } from "@/lib/ga";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) setVisible(true);
    else if (consent === "granted") loadGA();
  }, []);

  const decide = (value) => {
    localStorage.setItem("cookie_consent", value);
    if (value === "granted") loadGA();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent"
      role="dialog"
      aria-label="Preferenze cookie"
      className="fixed inset-x-3 bottom-3 z-[70] mx-auto max-w-3xl rounded-2xl border border-black/10 bg-[var(--ink-850)] p-5 shadow-2xl sm:inset-x-auto sm:right-5"
    >
      <div className="flex items-start gap-3">
        <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-emerald-600/12 text-emerald-700">
          <Cookie className="h-4 w-4" />
        </span>
        <div className="flex-1">
          <p className="text-sm leading-relaxed text-secondary">
            Utilizziamo cookie tecnici e, previo consenso, cookie di analisi
            (Google Analytics) per capire come viene usato il sito. Puoi
            accettare o rifiutare. Dettagli nella{" "}
            <a
              href="/cookie"
              className="text-emerald-700 underline underline-offset-2"
            >
              Cookie Policy
            </a>
            .
          </p>
          <div className="mt-4 flex flex-wrap gap-2.5">
            <button
              data-testid="cookie-accept"
              onClick={() => decide("granted")}
              className="h-10 rounded-lg bg-emerald-700 px-4 text-sm font-medium text-white transition-colors duration-200 hover:bg-emerald-600"
            >
              Accetta
            </button>
            <button
              data-testid="cookie-reject"
              onClick={() => decide("denied")}
              className="h-10 rounded-lg border border-black/15 bg-transparent px-4 text-sm font-medium text-[color:var(--text-primary)] transition-colors duration-200 hover:bg-black/[0.04]"
            >
              Rifiuta
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
